module.exports = __webpack_public_path__ + "images/menu-contents-sel.svg?3f1e5cd7763f743187b7f74af417a24c";